import { RFMDecisionEnum, RFMInvitation } from 'domains/workspaceDomain';
import { isEmpty } from 'lodash-es';
import React, { useMemo } from 'react';
import './OfferResultChart.less';

const OfferResultChart = ({
  invitations,
}: {
  invitations: RFMInvitation[];
}) => {
  const [declined, notOpened, accepted, noActions] = useMemo(() => {
    let declined = 0,
      notOpened = 0,
      accepted = 0,
      noActions = 0;
    if (!isEmpty(invitations)) {
      declined = Math.round(
        (invitations!.filter((inv) => inv.decision === RFMDecisionEnum.DECLINED)
          .length /
          invitations!.length) *
          100
      );
      accepted = Math.round(
        (invitations!.filter(
          (inv) => inv.opened && inv.decision === RFMDecisionEnum.ACCEPTED
        ).length /
          invitations!.length) *
          100
      );
      notOpened = Math.round(
        (invitations!.filter((inv) => !inv.opened).length /
          invitations!.length) *
          100
      );
      noActions = 100 - notOpened - declined - accepted;
    }
    return [declined, notOpened, accepted, noActions];
  }, [invitations]);

  return isEmpty(invitations) ? (
    <></>
  ) : (
    <div className="offer-result-chart">
      <div className="offer-result-chart-bar">
        {!!declined && (
          <div
            className="offer-result-chart-bar declined"
            style={{ width: declined + '%' }}
          ></div>
        )}
        {!!accepted && (
          <div
            className="offer-result-chart-bar accepted"
            style={{ width: accepted + '%' }}
          ></div>
        )}
        {!!noActions && (
          <div
            className="offer-result-chart-bar no-actions"
            style={{ width: noActions + '%' }}
          ></div>
        )}
        {!!notOpened && (
          <div
            className="offer-result-chart-bar not-opened"
            style={{ width: notOpened + '%' }}
          ></div>
        )}
      </div>
      <div className="offer-result-chart-legend">
        <div className="offer-result-chart-legend-item">
          <div className="offer-result-chart-legend-item-bullet declined"></div>
          {declined + '%'} Declined
        </div>
        <div className="offer-result-chart-legend-item">
          <div className="offer-result-chart-legend-item-bullet accepted"></div>
          {accepted + '%'} Accepted
        </div>
        <div className="offer-result-chart-legend-item">
          <div className="offer-result-chart-legend-item-bullet no-actions"></div>
          {noActions + '%'} No Actions
        </div>
        <div className="offer-result-chart-legend-item">
          <div className="offer-result-chart-legend-item-bullet not-opened"></div>
          {notOpened + '%'} Not Opened
        </div>
      </div>
    </div>
  );
};

export default OfferResultChart;
